import React from "react";
import Moment from "moment";
import { extendMoment } from "moment-range";
import { union } from "lodash";
import { EventList } from "./EventList";
import { useStateValue } from "../App";
import queryString from "qs";

const moment = extendMoment(Moment);

export const MonthSimple = (props) => {
  const today = moment();

  let year = parseInt(props.year) + (props.month>12?1:0);

  const month = moment(
    `01-${("0" + (props.month>12?props.month-12:props.month)).slice(-2)}-${year}`,
    "DD-MM-YYYY"
  );

  let tinyView = props.view === "year" && !props.canCreateItems;// ? "month" : "day";
  let firstDay = month.isoWeekday();
  let daysInMonth = month.daysInMonth();

  const days = [];

  let day = 1;

  const monthRange = moment.range(month, moment(month).endOf("month"));

  const filteredEvents = [];

  props.events.forEach((event) => {

    let start = moment(event.start, "YYYYMMDD");
    let end = moment(event.end, "YYYYMMDD");
    event.week = 'Week ' +start.week();
    event.dateText = start.format("dddd D MMMM YYYY");
    if((start.year() >= month.year() && start.year() <= month.year()+1) || (end.year() >= month.year() && end.year() <= month.year()+1)) {
      filteredEvents.push(event);


      if (event.start !== event.end) {

        /*let diff = end.diff(start, 'days') + 1;
        let dag = 1;
        event.subtitle = "dag " + dag + " van " + diff + "";
        while (end.isAfter(start)) {
          let e = Object.assign({}, event);
          e.subtitle = "dag " + (++dag) + " van " + diff + "";
          start = start.add(1, 'day');
          e.start = start.format('YYYYMMDD');
          filteredEvents.push(e);
        }*/
        if(start.week() !== end.week()) {
          event.week += " t/m<br>Week " + end.week();
        }
        event.dateText += " t/m<br>" + end.format("dddd D MMMM YYYY");
      }
    }
  });

  filteredEvents.sort((a, b) => { return a.start - b.start; });

  if (props.view === "year") {

    return (
      <div className="monthSimple" id={month.format("MMMM")}>


          <div className="monthSimple__event" key={'header'}>
            <div className="monthSimple__eventWeek"><b>Week</b></div>
            <div className="monthSimple__eventDate"><b>Datum</b></div>
            <div className="monthSimple__eventTime"><b>Tijd</b></div>
            <div className="monthSimple__eventTitle"><b>Item</b></div>
            <div className="monthSimple__eventMemo" style={{whiteSpace: "pre-wrap"}}>
              <b>Notitie</b>
            </div>
          </div>


        {filteredEvents.map((event) => (


                <div className="monthSimple__event" key={event.id}>
                  <div className="monthSimple__eventWeek" dangerouslySetInnerHTML={{__html:event.week}} />
                    <div className="monthSimple__eventDate" dangerouslySetInnerHTML={{__html:event.dateText}} />
                  <div className="monthSimple__eventTime">
                    {event.start_time !== "00:00" && event.end_time != "23:59" ? (
                      event.start_time + " - " + event.end_time
                    ) : (
                        event.hasOwnProperty('subtitle')?event.subtitle:""
                    )
                    }
                  </div>
                    <div className="monthSimple__eventTitle">
                      <ul><li className={event.created_by != null?'isUserEvent':''}>{event.title}</li></ul>
                    </div>
                  <div className="monthSimple__eventMemo" style={{whiteSpace: "pre-wrap"}}>
                    {event.notes}
                  </div>
                </div>


        ))}

      </div>
    );
  }

  return (
    <div className="month" id={month.format("MMMM")}  style={props.month === 13? {pageBreakBefore: 'always'}: {}}>
      <div className="month__calendarHeader">{month.format("MMMM YYYY")}</div>
      <div className="month__calendarDays">
        <DaysInAWeek />
      </div>
      <div className="month__calendarWeeks">
        <Weeks days={days} view={props.view} weeks={weeks} />
      </div>
      <div className="month__calendarDates">
        {days.map((day, index) => (
          <Day key={index} day={day} today={today} {...props} />
        ))}
      </div>
    </div>
  );
};

const DaysInWeek = (props) => {
  const { days, week, today } = props;
  const daysInWeek = days.filter(
    (day) => day.active && day.date.week() == week
  );

  return (
    <div className="month__calendarDates">
      {daysInWeek.map((day, index) => (
        <Day key={index} day={day} today={today} {...props} />
      ))}
    </div>
  );
};

const Day = React.memo(({ day, openPopup, view, events, today }) => {
  const [{ date }, dispatch] = useStateValue();
  const dayRef = React.useRef();

  React.useEffect(() => {
    if (
      dayRef.current !== null &&
      date &&
      date === day.date.format("DD-MM-YYYY")
    ) {
      openPopup(day, null, dayRef.current);

      window.scrollTo({
        top: dayRef.current.getBoundingClientRect().top - 150,
        left: 0,
        behavior: "smooth",
      });

      dispatch({ type: "removeDate" });

      var updatedQuery = {
        ...queryString.parse(window.location.search.replace("?", "")),
      };

      delete updatedQuery.date;

      // Create the new url and push it into the history API
      const newUrl = `${window.location.origin}${
        window.location.pathname
      }?${queryString.stringify(updatedQuery)}`;

      window.history.pushState({}, "", newUrl);
    }
  }, [dayRef]);

  if (!day.active && view == "year") return null;

  const classes = ["date", "calendar__cell"];

  if (day.date.isSame(today, "d")) classes.push("isToday");
  if (!day.active) classes.push("isInactive");

  const eventsToday = events.filter((event) => {
    if (event.start === day.date.format("YYYYMMDD") && day.active) return event;
    if (event.range !== false && event.range.contains(day.date)) return event;
  });

  eventsToday.forEach((event) => {
    const eventType = event.created_by == null ? "" : "User";
    classes.push(`has${eventType}Event`);

    if (event.range !== false) {
      // is period
      if (event.start === day.date.format("YYYYMMDD")) {
        classes.push(`isStartOf${eventType}Period`);
      } else if (event.end === day.date.format("YYYYMMDD")) {
        classes.push(`isEndOf${eventType}Period`);
      } else {
        classes.push(`isIn${eventType}Period`);
      }
    }
  });

  const title = getTitleForDate(day.date, eventsToday);

  switch (view) {
    case "month":
      return (
        <span
          ref={dayRef}
          className={Array.from(new Set(classes)).join(" ")}
          onClick={(event) => openPopup(day, event)}
          title={title}
        >
          <span>
            <span className="label">{day.date.date()}</span>
            <EventList events={events} date={day.date} ncolor={'#ffffff'}/>
            <button className="addEventBtn btn">
              <i className="fal fa-plus"></i>
            </button>
          </span>
        </span>
      );
    case "smallMonth":
      return (
        <span
          ref={dayRef}
          className={Array.from(new Set(classes)).join(" ")}
          onClick={(event) => openPopup(day, event)}
          title={title}
        >
          <span>{day.date.date()}</span>
        </span>
      );
    case "year":

      
      return (/*eventListItems.length > 0*/ true && (
        <span
          ref={dayRef}
          className={Array.from(new Set(classes)).join(" ")}
          onClick={(event) => openPopup(day, event)}
          title={title}
        >
          <span className="label">{day.date.date()}</span>
          <span className="labelDay">{day.date.format("dd")}</span>
          <EventList events={events} date={day.date} ncolor={'#566971'}/>
          <button className="addEventBtn btn">
            <i className="fal fa-plus"></i>
          </button>
        </span>
      ));
  }

  return null;
});

const DaysInAWeek = () => {
  const items = [];

  for (let d = 1; d < 8; d++) {
    items.push(
      <span key={d} className="calendar__cell">
        <span>{moment().day(d).format("dd")}</span>
      </span>
    );
  }

  return items;
};

const Weeks = ({ days, view, weeks }) => {
  const items = [];

  for (let r = 0; r < weeks.length; r++) {
    items.push(
      <span key={r}>
        {view == "year" ? <span>Wk</span> : null}
        {days[7 * r].date.week()}
      </span>
    );
  }

  return (
    <>
      {view !== "year" ? <span>Wk</span> : null}
      {items}
    </>
  );
};

export const getNumWeeksInMonth = (momentObj) => {
  return (
    moment
      .duration(
        moment(momentObj).endOf("month") - moment(momentObj).startOf("month")
      )
      .weeks() + 1
  );
};

const getTitleForDate = (date, events) => {
  if (events.length > 0) {
    return events
      .map((event, index) => {
        if (index > 2) {
          return "";
        }
        return event.title;
      })
      .join(", ");
  }

  return date.format("DD MMMM YYYY");
};
